module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppCaseItemsDataTableBase', {
    attrs: {
      "casesid": _vm.casesid,
      "item-type": _vm.serviceTypeID
    },
    scopedSlots: _vm._u([{
      key: "bottom",
      fn: function(props) {
        return [_c('AttachServicesToCaseButton', {
          attrs: {
            "casesid": props.casesid
          },
          on: {
            "resource-attached": props.loadListing
          }
        }), _vm._v(" "), _c('AppEditItemCheckListDialog', {
          attrs: {
            "item-id": props.itemForCheckList.id,
            "item-type": _vm.serviceTypeID,
            "cases-id": _vm.casesid
          },
          on: {
            "update:itemId": function($event) {
              return _vm.$set(props.itemForCheckList, "id", $event)
            },
            "update:item-id": function($event) {
              return _vm.$set(props.itemForCheckList, "id", $event)
            }
          }
        })]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b0580ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatables/CaseServicesDataTable.vue
// module id = 966
// module chunks = 1